'use client'

/**
 * Typing Indicator Component
 *
 * Shows animated dots while the assistant is processing/thinking.
 */

import { Bot } from 'lucide-react'

export function TypingIndicator() {
  return (
    <div className="flex gap-2">
      {/* Avatar */}
      <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-muted">
        <Bot className="h-4 w-4" />
      </div>

      {/* Typing bubble */}
      <div className="rounded-xl bg-muted px-4 py-3">
        <div className="flex items-center gap-1">
          <span
            className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground/60"
            style={{ animationDelay: '0ms' }}
          />
          <span
            className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground/60"
            style={{ animationDelay: '150ms' }}
          />
          <span
            className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground/60"
            style={{ animationDelay: '300ms' }}
          />
        </div>
      </div>
    </div>
  )
}
